import { createStyles, makeStyles } from '@mui/styles';
import { NextTheme } from '../../../layout/theme-next/provider';

export const styles = makeStyles<NextTheme>((theme) =>
  createStyles({
    editorContainer: {
      display: 'inline-block',
      width: '50%',
      padding: 10,
      height: '100%',
    },
    editor: {
      width: '100%',
      height: '59vh',
      maxHeight: '59vh',
      overflow: 'auto',
      display: 'inline-block',
    },
    hiddenEditor: {
      display: 'none',
    },
    fullWidth: {
      width: '100%',
    },
    font: {
      fontWeight: 500,
    },
  }),
);
